import React, { Component } from 'react';
import { Tooltip } from 'antd';
import L, { FeatureGroup, map } from 'leaflet'
import './Toolbar.scss';
import context from '../../context';
export default class Toolbar extends Component {
    // featureGroup = null;
    featureGroup = null;
    polygonLayer = null;
    polygonPoints = [];
    constructor(props) {
        super(props)
        this.state = {
            tools: context.appConfig.toolbar || [],
            selected: null,
        };


        // this.featureGroup = new FeatureGroup();
        // context.map.addLayer(this.featureGroup)
    }
    componentDidMount() {

    }
    componentDidUpdate() {

    }
    componentWillUnmount() {

    }
    onSelect = (value) => {
        this.setState({
            selected: value
        });
    }
    render() {
        let { tools, selected } = this.state;
        return (
            <div className="tool_bar">
                {
                    tools && tools.map(m => {
                        return <div className='tool_item' key={m.id} style={{ background: (selected === m.id) ? "#98d2d2" : "" }}>
                            <Tooltip placement="bottom" title={m.name} arrow={true}>
                                <span className={"icon iconfont " + m.icon} onClick={() => this.onSelect(m.id)}></span>
                            </Tooltip>
                        </div>
                    })
                }
            </div>
        )
    }
}
